<template>
	<div v-loading.fullscreen.lock="visible.loading" element-loading-background="rgba(0, 0, 0, 0.4)">
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item><i class="el-icon-lx-calendar"></i> 门禁报表</el-breadcrumb-item>
				<el-breadcrumb-item>临时卡业务</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<div class="container" v-if="power.search">
			<div class="handle-box left">
				<el-select v-model="data.type" placeholder="门岗" size="large" style="width:100px" class="left mr10"
					:clearable="false">
					<el-option :value="0" label="全部"></el-option>
					<el-option :value="1" label="人员"></el-option>
					<el-option :value="2" label="车辆"></el-option>
				</el-select>
				<el-select v-model="data.doorPost" placeholder="门岗" size="large" style="width:140px" class="left mr10"
					:clearable="false">
					<el-option :value="0" label="全部"></el-option>
					<el-option :value="1" label="1#岗/7#岗"></el-option>
					<el-option :value="2" label="2#岗"></el-option>
					<el-option :value="3" label="6#岗"></el-option>
					<el-option :value="4" label="1#办公楼"></el-option>
				</el-select>
				<el-input v-model="data.filterstr" placeholder="人员姓名/身份证" class="left mr10" size="large"
					style="width:260px" clearable></el-input>
				<el-input v-model="data.cardcode" placeholder="卡编号" class="left mr10" size="large" style="width:260px"
					clearable></el-input>
				<el-button type="primary" icon="el-icon-search" @click="search"
					v-if="power.search">搜索</el-button>
				<el-button type="warning" icon="el-icon-delete-location" @click="toForceOut"
					v-if="power.fout" :disabled="data.curInfo.id == 0 || data.curInfo.visitorType == 0 || data.curInfo.visitorType == 4">强制退场</el-button>
			</div>
			<el-table id="applyRecordReportTable" ref="table" :data="data.rows" border class="table" height="570"
				highlight-current-row @current-change="setCurrent">
				<el-table-column prop="visType" label="访客类型" width="110">
				</el-table-column>
				<el-table-column prop="cardCode" label="卡编号" width="90">
				</el-table-column>
				<el-table-column prop="name" label="姓名/车牌号" width="140">
				</el-table-column>
				<el-table-column prop="idno" label="身份证" width="230">
				</el-table-column>
				<el-table-column prop="deptName" label="引进部门" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="doorPost" label="授权点" width="120">
				</el-table-column>
				<el-table-column prop="visTime" label="办理时间" width="210">
				</el-table-column>
			</el-table>
			<div class="pagination">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentPageChange"
					:current-page="data.page" :page-sizes="[10,14,20,50,100,200,300,400,500]" :page-size="data.size"
					layout="total, sizes, prev, pager, next, jumper" :total="data.total">
				</el-pagination>
			</div>
		</div>

		<el-dialog title="强制退场确认" :visible.sync="visible.fout" :close-on-click-modal="false"
			width="400px">
			<el-form :model="data.curInfo" label-width="80px">
				<el-form-item label="姓名">
					<el-input v-model="data.curInfo.name" readonly/>
				</el-form-item>
				<el-form-item label="身份证">
					<el-input v-model="data.curInfo.idno" readonly/>
				</el-form-item>
				<el-form-item label="门岗">
					<el-input v-model="data.curInfo.doorPost" readonly/>
				</el-form-item>
				<el-form-item label="选项">
					<el-checkbox v-model="data.curInfo.clearPP">清除人员申请权限</el-checkbox>
					<el-checkbox v-model="data.curInfo.clearVP">清除车辆申请权限</el-checkbox>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="doForceOut()">确认清场</el-button>
					<el-button @click="setCurrent();visible.fout = false;">取消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	import printJS from 'print-js';
	export default {
		name: 'applyrecordreport',
		data() {
			return {
				data: {
					filterstr: '',
					type: 0,
					doorPost: 0,
					cardcode: '',
					rows: [],
					total: 0,
					size: 14,
					page: 1,
					curInfo: {
						id: 0,
						idno: '',
						name: '',
						doorPost: '',
						visitorType: 0,
						clearPP: true,
						clearVP: true
					}
				},
				visible: {
					fout: false
				},
				power: {
					pageId: 112,
					search: false,
					fout: false
				}
			}
		},
		methods: {
			search(change) {
				let ths = this;
				ths.visible.loading = true;
				if (change) {
					ths.data.page = 1;
				}
				let query = '?sign=' + window.$gloable.userinfo.sign + '&doorpost=' + ths.data.doorPost + '&type=' + ths
					.data.type +
					'&cardcode=' + ths.data.cardcode + '&pagesize=' + ths.data.size + '&currentpage=' + ths.data.page +
					'&deptname=' + ths.data.deptname + '&mobile=' + ths.data.mobile + '&filterstr=' + ths.data.filterstr;
				window.ax.get('api/personnal/template/inusepagerlist' + query, {}).then(rsp => {
					let data = rsp.data;
					if (data.code == 1) {
						data = data.data;
						let len = data.datas.length;
						let total = data.totalRecord;
						ths.data.rows = data.datas;
						ths.data.total = total;
						if (len == 0 && total > 0) {
							ths.data.page = Math.ceil(total / ths.data.size);
							ths.search();
						}
						ths.setCurrent();
					} else {
						ths.$message.error(data.message);
					}
					ths.visible.loading = false;
				}).catch(err => {
					ths.$message.error('执行脚本出错，请联系管理员');
					console.log(err);
					ths.visible.loading = false;
				});
			},
			handleSizeChange(size) {
				this.data.size = size;
				this.data.page = 1;
				this.search();
			},
			handleCurrentPageChange(current) {
				this.data.page = current;
				this.search();
			},
			setCurrent(r) {
				let ths = this;
				ths.$refs.table.setCurrentRow(r);
				if (r) {
					ths.data.curInfo.id = r.id;
					ths.data.curInfo.idno = r.idno;
					ths.data.curInfo.name = r.name;
					ths.data.curInfo.doorPost = r.doorPost;
					ths.data.curInfo.doorPostId = r.doorPostId;
					ths.data.curInfo.visitorType = r.visitorType;
					ths.data.curInfo.clearPP = true;
					if (r.visitorType == 2) {
						ths.data.curInfo.clearVP = true;
					} else {
						ths.data.curInfo.clearVP = false;
					}
				} else {
					ths.data.curInfo.id = 0;
					ths.data.curInfo.idno = '';
					ths.data.curInfo.name = '';
					ths.data.curInfo.doorPost = '';
					ths.data.curInfo.visitorType = 0;
					ths.data.curInfo.doorPostId = 0;
					ths.data.curInfo.clearPP = true;
					ths.data.curInfo.clearVP = true;
				}
			},
			toForceOut() {
				let ths = this;
				let ci = ths.data.curInfo;
				if (ci.idno) {
					ths.visible.fout = true;
				}
			},
			doForceOut() {
				let ths = this;
				ths.visible.loading = true;
				let ci = ths.data.curInfo;
				var data = { sign: window.$gloable.userinfo.sign, id: ci.id, ClearPersonPower: ci.clearPP, ClearVehiclePower:ci.clearVP };
				window.ax.post('api/personnal/template/clearPower', data).then(rsp => {
					let data = rsp.data;
					if (data.code == 1) {
						ths.$message.info(data.message);
					} else {
						ths.$message.error(data.message);
					}
					ths.visible.loading = false;
				}).catch(err => {
					ths.$message.error('执行脚本出错，请联系管理员');
					console.log(err);
					ths.visible.loading = false;
				});
			}
		},
		created() {
			let ths = this;
			ths.baseJS.initPower(ths.power);
			ths.search();
		},
		mounted() {}
	}
</script>

<style scoped>
	.is-current {
		background: #cccccc;
	}

	.handle-box {
		margin-bottom: 20px;
	}

	.left {
		float: left;
	}

	.right {
		float: right;
	}

	.handle-select {
		width: 120px;
	}

	.handle-input {
		width: 300px;
		display: inline-block;
	}

	.del-dialog-cnt {
		font-size: 16px;
		text-align: center
	}

	.table {
		width: 100%;
		font-size: 14px;
	}

	.mr10 {
		margin-right: 10px;
	}

	.m10 {
		margin: 10px;
	}

	.mt1 {
		margin-top: 1px;
	}

	.fr {
		float: right;
	}

	.form-warp {
		position: relative;
		width: 560px;
		height: 520px;
		padding-left: 200px;
		border: 1px solid #ccc;
	}

	.form-warp-left {
		position: absolute;
		left: 0;
		top: 0;
		width: 200px;
		height: 492px;
		padding-top: 28px
	}

	.department-search {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 28px;
		border-bottom: 1px solid #ddd;
		border-right: 1px solid #ddd;
	}

	.department-tree {
		position: relative;
		height: 490px;
		width: 100%;
		border-right: 1px solid #ddd
	}

	.form-warp-main {
		position: relative;
		height: 492px;
		width: 100%;
		padding-top: 28px
	}

	.employee-search {
		position: absolute;
		top: 0;
		left: 1px;
		width: 100%;
		height: 28px;
		border-bottom: 1px solid #ddd
	}

	.list {
		position: relative;
		height: 492px;
		width: 560px
	}

	.card-box {
		position: relative;
		float: left;
		width: 100px;
		height: 60px;
		border: 1px solid #ccc;
		background-color: #fff;
		border-radius: 3px;
		margin: 10px 0 0 10px;
		padding-left: 69px;
		overflow: hidden;
		-moz-user-select: none;
		-webkit-user-select: none;
		-ms-user-select: none;
		-khtml-user-select: none;
		user-select: none;
		cursor: pointer
	}

	.card-box.active {
		border: 1px solid #ff5d5b;
		background: url(../../assets/img/selected_red.png) right top no-repeat
	}

	.card-box-img {
		position: absolute;
		left: 0;
		top: 0;
		width: 56px;
		height: 60px;
		line-height: 60px;
		padding-left: 5px;
		background-color: #ebebeb;
		border-right: 1px solid #ccc
	}

	.card-box-img img {
		border-radius: 45px;
		width: 50px;
		height: 50px;
		margin-top: 5px;
	}

	.card-box-content {
		padding: 6px 0
	}

	.card-box-content p {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		margin: 0;
		font-size: 10px
	}

	.form-warp-right {
		position: absolute;
		top: 0;
		right: 0;
		height: 492px;
		width: 180px;
		border-left: 1px solid #ddd;
		padding-top: 28px;
		background-color: #fff;
		z-index: 10;
		transition: all 300ms;
		overflow-x: hidden;
		overflow-y: auto;
	}

	.form-warp-right.hide {
		width: 0px;
	}

	.form-warp-right-close {
		position: absolute;
		top: 7px;
		right: 4px;
		width: 12px;
		height: 13px;
		display: block;
		cursor: pointer
	}

	.form-warp-right-close:hover {
		background-position: 0 -12px
	}

	.form-warp-right-title {
		position: absolute;
		top: 0;
		right: 0;
		height: 28px;
		line-height: 27px;
		padding-left: 10px;
		width: 170px;
		border-bottom: 1px solid #ddd;
		cursor: pointer
	}

	.selected-list-warp {
		position: relative;
		height: 492px;
		width: 180px;
	}

	.selected-box {
		position: relative;
		width: 150px;
		height: 55px;
		border: 1px solid #ccc;
		border-radius: 4px;
		margin: auto;
		margin-top: 10px;
		padding: 5px 0 0 10px
	}

	.selected-box p {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		margin: 0
	}

	.remove {
		position: absolute;
		top: 2px;
		right: 2px;
		width: 12px;
		height: 13px;
		display: block;
		cursor: pointer;
		opacity: 0.5
	}

	.remove:hover {
		opacity: 1
	}

	.selected-btn {
		position: absolute;
		top: 0;
		right: 1px;
		height: 100%;
		width: 80px;
		line-height: 27px;
		text-align: center;
		border-left: 1px solid #ddd;
		cursor: pointer;
		background-color: #eee;
		color: #666
	}

	.selected-btn:hover {
		color: #333
	}

	.form-control {
		border: 0;
		height: 100%;
	}

	.input-query {
		position: absolute;
		right: 146px;
		top: 5px;
		color: #ccc;
		font-size: 16px;
		cursor: pointer
	}

	.select-all {
		position: absolute;
		top: 0;
		right: 80px;
		height: 100%;
		width: 60px;
		line-height: 27px;
		text-align: center;
		border-left: 1px solid #ddd;
		cursor: pointer;
		background-color: #eee;
		color: #666
	}

	.span-ellipsis {
		width: 100%;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		display: block;
	}
</style>